// extracted by mini-css-extract-plugin
export var container = "_8p-0";
export var error = "_8p-9";
export var label = "_8p-5";
export var light = "_8p-6";
export var md = "_8p-3";
export var sm = "_8p-2";
export var thin = "_8p-8";
export var thinBold = "_8p-7";
export var vertical = "_8p-4";
export var xs = "_8p-1";